import type {z} from "zod";

import {EditClientNoteBody} from "@project/sdk/sales/zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const editClientNoteTitleSchema = requiredStringSchema(
  EditClientNoteBody.shape.title,
  noteFieldLabelIds.title,
);
export const editClientNoteContentSchema = requiredStringSchema(
  EditClientNoteBody.shape.content,
  noteFieldLabelIds.content,
);

export const editClientNoteFormSchema = EditClientNoteBody.extend({
  title: editClientNoteTitleSchema,
  content: editClientNoteContentSchema,
});
export type EditClientNoteFormPayload = z.output<typeof editClientNoteFormSchema>;

export const draftEditClientNoteFormSchema = editClientNoteFormSchema.partial();
export type DraftEditClientNoteFormPayload = z.output<typeof draftEditClientNoteFormSchema>;
